import { forwardRef } from "react";

import MuiButton, {
  type ButtonProps as MuiButtonProps,
} from "@mui/material/Button";

// Re-exported so consumers never import MUI types directly. Narrows in future
// as the design system imposes its own constraints.
export type ButtonProps = MuiButtonProps;

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  function Button({ variant = "contained", color = "primary", ...rest }, ref) {
    return <MuiButton ref={ref} variant={variant} color={color} {...rest} />;
  },
);
